import { Button, Typography } from '@maas-components/core'
import styled, { css } from 'styled-components'
import { ITypographyStyledProps } from './types'

export const ButtonStyled = styled(Button)`
  background-color: ${({ theme }) => theme.palette.primary.contrastText};
  overflow: hidden;

  & [class*='MuiButton-label'] {
    height: 100%;
  }

  & img,
  svg {
    max-width: 100px;
  }

  ${({ disabled }) =>
    disabled &&
    css`
      mix-blend-mode: luminosity;
      cursor: not-allowed;
    `}
`

export const TypographyStyled = styled(Typography)<ITypographyStyledProps & { selected?: boolean }>`
  font-size: ${({ theme }) => theme.typography.pxToRem(14)};
  font-weight: ${({ theme }) => theme.typography.fontWeightMedium};
  background-color: ${({ selected }) => (selected ? '#0086ff' : 'rgba(0, 134, 255, 0.1)')};
  color: ${({ selected, theme }) => (selected ? '#fff' : theme.palette.secondary.dark)};

  padding-top: ${({ theme }) => theme.spacing(1.5)}px;
  padding-bottom: ${({ theme }) => theme.spacing(1.5)}px;
  overflow-wrap: break-word;

  ${({ $isDefault }) =>
    $isDefault &&
    css`
      color: ${({ theme }) => theme.palette.primary.main};
      background-color: unset;
    `}
`

export const ContainerIconDefaultStyled = styled.div`
  height: ${({ theme }) => theme.typography.pxToRem(64)};
  width: ${({ theme }) => theme.typography.pxToRem(64)};
  border: 2px solid ${({ theme }) => theme.palette.primary.main};
  border-radius: ${({ theme }) => theme.typography.pxToRem(32)};
`
